import ApiResponse from '@/models/ApiResponse'
import { DehaatPosts } from '@/models/Posts'
import { get } from '@/utils/axios'

interface Params {
  type: string
  page: number
  page_size: number
  lang: string
}

const fetchRelatedPosts = async (url: string, params?: Partial<Params>) => {
  try {
    return await get<ApiResponse<DehaatPosts>>(url, params)
  } catch (e) {
    console.error(e)
  }
  return null
}

export default fetchRelatedPosts
